<!--
  ~ Copyright (c) 2024 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<p-messages
  [severity]="'info'">
  <ng-template pTemplate>
    <div class='d-flex align-items-center p-1 gap-3'>
      <span class='d-flex flex-grow-0'>
        <i [ngClass]="'fa-solid fa-asterisk'" class='ui-icon-info info-icon'></i>
      </span>
      <div class='flex-grow-1'>
        <span class='info-text'>
          <i class='fa-solid fa-triangle-exclamation me-1'></i>
          <span
            [innerHTML]="translationSchema.efactura.officeAddressStateCountryMessage | translate | safe : 'html'"></span>
          <br>
          <i class='fa-solid fa-triangle-exclamation me-1'></i>
          <span
            [innerHTML]="translationSchema.efactura.officeAddressBucharestMessage | translate | safe : 'html'"></span>
        </span>
      </div>
    </div>
  </ng-template>
</p-messages>


